const tinyHeader = (editor) => {
  if (!editor.dom) return;

  const container = editor.getContainer();

  const header = container.querySelector(".tox-editor-header");
  const menubar = header.querySelector(".tox-menubar");
  if (menubar) {
    const newDiv = document.createElement("div");
    newDiv.classList.add("my-custom-menu");
    newDiv.innerHTML = ` <div  class="t-menu">
    <div data-custom-menu="xml" class="t-head-menu" >
          <svg
            style="margin-top:1.5px;"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_2961_1789)">
              <path
                d="M3.00058 12.7518V14.2506C3.00058 14.6809 3.17366 15.0942 3.48193 15.4025C3.7902 15.7108 4.20354 15.8839 4.63384 15.8839H13.3668C13.7971 15.8839 14.2104 15.7108 14.5187 15.4025C14.8269 15.0942 15.0000 14.6809 15.0000 14.2506V12.7518"
                stroke="#414E62"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M5.00058 6.25059L9.00029 2.50029L13.0000 6.25059"
                stroke="#414E62"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M9.00029 2.50029V11.667"
                stroke="#414E62"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_2961_1789">
                <rect width="18" height="18" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <span>Upload XML</span>
        </div>
        <div data-custom-menu="upload" class="t-head-menu" >
          <svg
            style="margin-top:1.5px;"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_2961_1789)">
              <path
                d="M3.00058 12.7518V14.2506C3.00058 14.6809 3.17366 15.0942 3.48193 15.4025C3.7902 15.7108 4.20354 15.8839 4.63384 15.8839H13.3668C13.7971 15.8839 14.2104 15.7108 14.5187 15.4025C14.8269 15.0942 15.0000 14.6809 15.0000 14.2506V12.7518"
                stroke="#414E62"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M5.00058 6.25059L9.00029 2.50029L13.0000 6.25059"
                stroke="#414E62"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M9.00029 2.50029V11.667"
                stroke="#414E62"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_2961_1789">
                <rect width="18" height="18" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <span>Upload File</span>
        </div>
        <div data-custom-menu="help" class="t-head-menu">
          <svg
            style="margin-top:2.5px;"
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            stroke="currentColor"
            stroke-width="1.3125"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="icon icon-tabler icons-tabler-outline icon-tabler-help"
          >
            <path stroke="none" d="M0 0h18v18H0z" fill="none" />
            <path d="M9 9m-6.75 0a6.75 6.75 0 1 0 13.5 0a6.75 6.75 0 1 0 -13.5 0" />
            <path d="M9 12.75l0 .01" />
            <path d="M9 10.125a1.125 1.125 0 0 1 .75 -1.125a1.95 1.95 0 1 0 -2.25 -3" />
          </svg>
          <span>Help</span>
        </div>
      </div>
       <div style="display:none" data-custom-menu="user" class="t-head-menu">
        <svg
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_2935_3290)">
            <path
              d="M3.5 14C3.5 15.3789 3.77159 16.7443 4.29926 18.0182C4.82694 19.2921 5.60036 20.4496 6.57538 21.4246C7.55039 22.3996 8.70791 23.1731 9.98182 23.7007C11.2557 24.2284 12.6211 24.5 14 24.5C15.3789 24.5 16.7443 24.2284 18.0182 23.7007C19.2921 23.1731 20.4496 22.3996 21.4246 21.4246C22.3996 20.4496 23.1731 19.2921 23.7007 18.0182C24.2284 16.7443 24.5 15.3789 24.5 14C24.5 12.6211 24.2284 11.2557 23.7007 9.98182C23.1731 8.70791 22.3996 7.55039 21.4246 6.57538C20.4496 5.60036 19.2921 4.82694 18.0182 4.29927C16.7443 3.77159 15.3789 3.5 14 3.5C12.6211 3.5 11.2557 3.77159 9.98182 4.29927C8.70791 4.82694 7.55039 5.60036 6.57538 6.57538C5.60036 7.55039 4.82694 8.70791 4.29926 9.98182C3.77159 11.2557 3.5 12.6211 3.5 14Z"
              stroke="#414E62"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M10.5 11.666C10.5 12.5943 10.8687 13.4845 11.5251 14.1409C12.1815 14.7973 13.0717 15.166 14 15.166C14.9283 15.166 15.8185 14.7973 16.4749 14.1409C17.1313 13.4845 17.5 12.5943 17.5 11.666C17.5 10.7378 17.1313 9.84752 16.4749 9.19114C15.8185 8.53476 14.9283 8.16602 14 8.16602C13.0717 8.16602 12.1815 8.53476 11.5251 9.19114C10.8687 9.84752 10.5 10.7378 10.5 11.666Z"
              stroke="#414E62"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M7.19531 21.9899C7.48407 21.0288 8.07494 20.1864 8.88027 19.5877C9.68559 18.9889 10.6625 18.6657 11.666 18.666H16.3326C17.3374 18.6657 18.3155 18.9896 19.1214 19.5898C19.9273 20.1899 20.518 21.0341 20.8056 21.9968"
              stroke="#414E62"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_2935_3290">
              <rect width="28" height="28" fill="white" />
            </clipPath>
          </defs>
        </svg>

        <svg
          width="7"
          height="4"
          viewBox="0 0 7 4"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.49889 0C6.92488 0 7.14738 0.492991 6.89038 0.811486L6.85238 0.853485L3.85243 3.85343C3.76634 3.93952 3.65179 3.99123 3.53028 3.99887C3.40877 4.00652 3.28864 3.96956 3.19244 3.89493L3.14545 3.85343L0.145498 0.853485L0.103998 0.806486L0.0769988 0.767987L0.0499993 0.719987L0.0414994 0.701988L0.0279996 0.668488L0.0119999 0.614489L0.00699985 0.58799L0.00200006 0.55799L0 0.529491V0.470492L0.00250001 0.441492L0.00699985 0.411493L0.0119999 0.385493L0.0279996 0.331494L0.0414994 0.297995L0.0764988 0.231996L0.108998 0.186997L0.145498 0.146498L0.192497 0.104998L0.230996 0.0779987L0.278995 0.0509992L0.296995 0.0424993L0.330494 0.0289993L0.384493 0.0129998L0.410993 0.00799976L0.440992 0.00299973L0.469492 0.00099991L6.49889 0Z"
            fill="#414E62"
          />
        </svg>
      </div> 
    `;
    menubar.appendChild(newDiv);
    const uploadBtn = newDiv.querySelector('[data-custom-menu="upload"]');
    const xmlBtn = newDiv.querySelector('[data-custom-menu="xml"]');
    const helpBtn = newDiv.querySelector('[data-custom-menu="help"]');
    if (uploadBtn) {
      uploadBtn.addEventListener("click", function () {
        editor.execCommand("uploadDoc");
      });
    }
     if (xmlBtn) {
      xmlBtn.addEventListener("click", function () {
        editor.execCommand("uploadXml");
      });
    }
    if (helpBtn) {
      helpBtn.addEventListener("click", function () {
        editor.execCommand("helping");
        console.log("comes");
      });
    }
  }
};

export { tinyHeader };
